import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { GASTOS } from './types';

export const buscarGastos = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/gastos/listar`, body, config);
        await dispatch({ type: GASTOS.BUSCAR, payload: res.data.gastos });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearGasto = (gastoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(gastoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/gastos/crear`, body, config);
        await dispatch({ type: GASTOS.AGREGAR, payload: res.data.gasto });
        await dispatch(setAlert(res.data.msg || 'Gasto creado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const editarGasto = (gastoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(gastoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/gastos/editar`, body, config);
        await dispatch({ type: GASTOS.EDITAR, payload: res.data.gasto });
        await dispatch(setAlert(res.data.msg || 'Gasto editado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const eliminarGasto = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/gastos/eliminar`, body, config);
        await dispatch({ type: GASTOS.ELIMINAR, payload: id });
        await dispatch(setAlert(res.data.msg || 'Gasto eliminado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const obtenerGasto = (id) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/gastos/detalles`, body, config);
        await dispatch({ type: GASTOS.DETALLES, payload: res.data.gasto });
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const crearGastoMultiple = (gastoData) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify(gastoData);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/gastos/crear-multiple`, body, config);
        await dispatch({ type: GASTOS.AGREGAR_MULTIPLE, payload: res.data.gastos });
        await dispatch(setAlert(res.data.msg || 'Gastos creados correctamente', 'success'));
        return true;
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
        return false;
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const limpiarGasto = () => dispatch => {
    dispatch({ type: GASTOS.LIMPIAR });
};
